import {Capability} from "../formElementCapability";
import {FormElementType} from "~/enums/formElementType";
import IFormElementSchema from "./iFormElementSchema";
import {InputFormatType} from "../../inputFormatType";

export const baseRestrictions: Capability[] = [
  Capability.defaultable,
  Capability.maskable,
  Capability.repeatable,
  Capability.lengthable,
  Capability.helpTextable,
  Capability.readonlyable,
  Capability.showHideable,
  Capability.formatable,
  Capability.sortable,
  Capability.destroyable,
];

const emailRestrictions: Capability[] = baseRestrictions.slice();
emailRestrictions.push(Capability.requireable);

export const restrictionSchema = {
  //Third Party Template Base Restrictions
  self: baseRestrictions,
  children: [
    {
      // First Name
      self: baseRestrictions,
    },
    {
      // Last Name
      self: baseRestrictions,
    },
    {
      // Email
      self: emailRestrictions,
    },
    {
      // Phone
      self: baseRestrictions,
    },
  ]
};

export const formElementsSchema: Array<IFormElementSchema> = [
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'First Name',
      sort_order: 0,
      is_required: true
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Last Name',
      sort_order: 1,
      is_required: true
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Email',
      sort_order: 2,
      is_required: true,
      format_type: InputFormatType.Email
    },
  },
];

